import React, { useEffect, useState } from 'react'
import Select from 'react-select'

import { Link, useHistory, useParams } from 'react-router-dom'
import { MdDone, MdKeyboardArrowLeft } from 'react-icons/md'
import Input from '../../../components/Input'
import api from '../../../services/api'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import './styles.css'
import { toast } from 'react-toastify'

interface RouteParams {
  id: string
}

interface iOption {
  label: string
  value: string
}

// Validate data from form
const truckSchema = Yup.object().shape({
  // owner: Yup
  //   .string()
  //   .max(80, "Tamanho máximo de 80 caracteres")
  //   .required("Nome do proprietário é obrigatório!"),
  //licensePlate: Yup
  //  .string()
  //  .required("Placa é obrigatório!"),
})

const EditTruckModel: React.FC = (): JSX.Element => {
  const [brandTypes, setBrandTypes] = useState<iOption[]>([
    { value: '', label: '' }
  ])

  const [brandValue, setBrandValue] = useState<iOption>({
    value: '',
    label: ''
  })
  /* const [modelValue, setModelValue] = useState<iOption>({ value: "", label: "" }) */

  const { handleSubmit, values, setValues, handleChange, errors } = useFormik({
    initialValues: {
      name: '',
      cpf: '',
      licensePlate: '',
      renavam: '',
      owner: '',
      vehicleModel: '',
      implementType: '',
      shaftQuantity: 0,
      grossCapacity: 0,
      netCapacity: 0
    },
    validationSchema: truckSchema,
    onSubmit: values => {
      api
        .post('truck-model/save', {
          id: Number(id),
          name: values.owner,
          truckBrand: {
            id: brandValue.value
          }
        })
        .then(() => {
          toast.success('Cadastro realizado com sucesso')
          setTimeout(() => {
            history.push('/modelos')
          }, 2500)
        })
        .catch(e => {
          toast.error('Erro ao Cadastrar: ' + e.response.data.code)
        })
    }
  })

  const { id } = useParams<RouteParams>()

  const history = useHistory()

  useEffect(() => {
    if (id) {
      api.get(`/truck-model/${id}`).then(response => {
        setValues({
          name: response.data.name,
          cpf: response.data.cpf,
          licensePlate: response.data.licensePlate,
          renavam: response.data.renavam,
          owner: response.data.name,
          vehicleModel: response.data.id,
          implementType: response.data.implementType,
          shaftQuantity: response.data.shaftQuantity,
          grossCapacity: response.data.grossCapacity,
          netCapacity: response.data.netCapacity
        })

        if (response.data.truckBrand) {
          setBrandValue({
            value: response.data.truckBrand.id,
            label: response.data.truckBrand.name
          })
          /* setModelValue({value: response.data.id,label: response.data.name}) */
        }
      })
    }

    api.get(`/truck-brand/`).then(response => {
      setBrandTypes(
        response.data.map((item: any) => {
          return { value: item.id, label: item.name }
        })
      )
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleChangeOptionBrand(option: iOption) {
    setBrandValue(option)

    // api.get(`/truck-model/brand/${option.value}`).then(response => {

    //   setModelTypes(response.data.map((item: any) => {
    //       return {value: item.id, label: item.name}
    //   }));

    // });
  }

  return (
    <div className='new-truck-container'>
      <form onSubmit={handleSubmit} autoComplete='off'>
        <header>
          <div>
            <strong>{`${!id ? ' Cadastrar ' : 'Editar'}`} Modelo</strong>
          </div>

          <div className='buttons-header'>
            <Link to='/modelos'>
              <button id='btBack' type='button'>
                <MdKeyboardArrowLeft size={20} color='#fff' />
                Voltar
              </button>
            </Link>
            <button id='btSave' type='submit'>
              <MdDone size={20} color='#fff' />
              Salvar
            </button>
          </div>
        </header>

        <div className='content'>
          <div className='row'>
            <div className={`input`}>
              <label>Marca: </label>
              <Select
                className='select-options'
                value={brandValue}
                options={brandTypes}
                onChange={option => handleChangeOptionBrand(option as iOption)}
              />
            </div>

            <div className={`input ${errors.owner ? 'error' : ''}`}>
              <Input
                name='owner'
                placeholder='Nome'
                onChange={handleChange}
                value={values.owner}
                label='Nome'
                maxLength={50}
              />
              {errors.owner && (
                <div className='validateError'>{errors.owner}</div>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default EditTruckModel
